import React, { useState, useEffect, useContext, Fragment } from "react";
import { AuthContext } from '../../context/Auth.context';
import { Link } from "react-router-dom";
import { dateFormat } from "../functions/dateFormat";
import Spinner from "../helpers/Spinner";
import { categoriesAccountingInfo } from "../services/salesServices";
import Toast from "../helpers/Toast";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const Accounting = () => {

    const { state, CheckResponse } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [date_from, setDateFrom] = useState("");
    const [date_to, setDateTo] = useState("");
    const [categories_accounting, setCategoriesAccounting] = useState([]);
    const [info_is_load, setInfoIsLoad] = useState(false);
    const [percentage, setPercentage] = useState([]);

    const showToast = (t, d, tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }

    const numberPrice = (n) => {
        return parseFloat(n).toFixed(2);
        // return parseFloat(newN);
    }

    const loadCategoriesAccounting = () => {
        if (date_from && date_to) {
            setLoading(true);
            categoriesAccountingInfo(state.auth, date_from, date_to).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    setCategoriesAccounting(data.categories_accounting);
                    setPercentage(data.categories_accounting.map(item => ({ id: item.id, percentage: 0 })));
                } else {
                    showToast('Oops!', 'Algo salio mal!', 'danger');
                }
                setInfoIsLoad(true);
                setLoading(false);
            })
        } else {
            showToast('Oops!', 'Selecciona un rango de fechas correcto', 'warning');
        }
    }

    const handleChangeDateFrom = (event) => {
        setDateFrom(event.target.value);
    };

    const handleChangeDateTo = (event) => {
        setDateTo(event.target.value);
    };

    const handleChangePercentage = (event, id_category) => {
        setPercentage(prevPercentajes =>
            prevPercentajes.map(item =>
                item.id === id_category ? { ...item, percentage: event.target.value } : item
            ));
    }

    const makeExcel = () => {
        if (date_from && date_to) {
            setLoading(true);

            const processedData = categories_accounting;

            if (!processedData || processedData.length === 0) {
                console.error("No data to process");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Ingresos');

            const header = ["Nombre", "SubTotal", "Excento", "IVA 16%", "Total"];
            worksheet.addRow(header);

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            });

            processedData.forEach((row) => {
                worksheet.addRow([row.name, numberPrice(row.sub_total), numberPrice(row.total_excento), numberPrice(row.total_tax), numberPrice(row.total)]);
            });

            worksheet.columns.forEach((column) => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, (cell) => {
                    const cellValue = cell.value ? cell.value.toString() : '';
                    maxLength = Math.max(maxLength, cellValue.length);
                });
                column.width = maxLength + 2;
            });

            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                saveAs(blob, `Reporte de ingresos ${date_from}-${date_to}.xlsx`);
            });

            setTimeout(() => {
                showToast('Hecho!', 'Reporte descargado', 'success');
                setLoading(false);
            }, 3000);
        } else {
            showToast('Oops!', 'Selecciona un rango de fechas correcto', 'warning');
        }
    };

    return (
        <>
            <Toast
                toastList={list}
            />
            <h1>Contabilidad</h1>

            <div className="row mt-5">
                <div className="col-sm-4 mt-1">
                    <label>De:</label>
                    <input type="date" value={date_from} onChange={(e) => handleChangeDateFrom(e)} className='form-control'></input>
                </div>
                <div className="col-sm-4 mt-1">
                    <label>A:</label>
                    <input type="date" value={date_to} onChange={(e) => handleChangeDateTo(e)} className='form-control'></input>
                </div>
                <div className="col-sm-2 mt-1">
                    <button className="btn btn-primary mt-4 me-2 w-100" onClick={() => { loadCategoriesAccounting() }}>Buscar</button>
                </div>
                <div className="col-sm-2 mt-1">
                    <button className="btn btn-success mt-4 w-100" onClick={() => { makeExcel() }}>Excel</button>
                </div>
                <div className="col-sm-2 mt-1">
                    <Link to="/accounting/taxes/" className="btn btn-primary mt-4 w-100">Impuestos</Link>
                </div>
            </div>

            {loading && <div className="col-sm-4 mt-1">
                <Spinner size={3} margin={4}></Spinner>
            </div>}
            {!loading && <>
                {info_is_load &&
                    <div className="row">
                        <div className="col-sm-12 mt-4">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Total</th>
                                        <th>Pagado en tarjeta</th>
                                        <th style={{ maxWidth: "150px", whiteSpace: "nowrap" }}>%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories_accounting?.map(item =>
                                        <tr key={item.id}>
                                            <td><Link to="/accounting/category-breackdown" state={{ date_from: date_from, date_to: date_to, category_id: item.id }}>
                                                {item.name}
                                            </Link></td>
                                            <td>{numberPrice(item.total - (item.total * ((percentage.find(percentaje => percentaje.id === item.id).percentage) / 100)))}</td>
                                            <td>{numberPrice(item.total_card_payment)}</td>
                                            <td style={{ maxWidth: "150px", whiteSpace: "nowrap" }}><div class="input-group">
                                                <input style={{ maxWidth: "80px" }} type="number" class="form-control"
                                                    onChange={(e) => handleChangePercentage(e, item.id)}
                                                    value={percentage.find(percentaje => percentaje.id === item.id).percentage} />
                                                <span class="input-group-text">%</span>
                                            </div></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>}
            </>}
        </>
    );
}

export default Accounting;